"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Normalizes event names to an array
 * @param  {String|String[]} event
 * @return {Array}
 */
function normalizeEvent(events) {
  return Array.isArray(events) ? events : [events];
}

exports.default = normalizeEvent;